<script setup lang="ts">
interface Props {
  showDialog: boolean
  title: string
  message: string
  confirmCopy?: string
  cancelCopy?: string
  options?: any
  confirmColor?: string
  noConfirmColor?: string
  loading?: boolean
}
const props = defineProps<Props>()

const emit = defineEmits<Emit>()

const defaultOptions = ref({
  color: 'grey lighten-3',
  width: 400,
  zIndex: 4001,
  noConfirmColor: 'gray',
  confirmColor: 'error',
  ...props.options,
})

interface Emit {
  (e: 'confirm', value: boolean): void
  (e: 'cancel', value: boolean): void
}

function onConfirm() {
  emit('confirm', true)
}

function onCancel() {
  emit('cancel', false)
}
</script>

<template>
  <VDialog
    :model-value="showDialog"
    :max-width="defaultOptions.width"
    :style="{ zIndex: defaultOptions.zIndex }"
    persistent
    @keydown.esc="onCancel"
  >
    <VCard>
      <VCardTitle class="text-wrap">
        <h3>
          {{ title }}
        </h3>
      </VCardTitle>
      <VCardText
        v-show="!!message"
        class="pa-4 body-1"
      >
        {{ message }}
      </VCardText>
      <VCardActions class="pa-4">
        <VBtn
          v-if="!defaultOptions.noconfirm"
          variant="text"
          :color="noConfirmColor ?? defaultOptions.noconfirmColor "
          :disabled="loading"
          @click="onCancel"
        >
          {{ cancelCopy || 'Go Back' }}
        </VBtn>
        <VSpacer />
        <VBtn
          variant="flat"
          :color="confirmColor ?? defaultOptions.confirmColor"
          :loading="loading"
          @click="onConfirm"
        >
          {{ confirmCopy || 'Confirm' }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
